import withAppData from './withAppData';

export default withAppData;
